import React from 'react';
import { motion } from 'framer-motion';
import '../styles/testimonials.css';
import { FaQuoteLeft, FaQuoteRight, FaCheckCircle } from 'react-icons/fa';
import l1 from "../assets/images/avtar1.png";

const reviews = [
  {
    id: 1,
    name: "Rahul Sharma",
    text: "BioSurge ko daily routine me add karna easy raha. Taste natural hai aur overall freshness feel hoti hai. Packaging bhi kaafi premium thi.",
    image: l1
  },
  {
    id: 2,
    name: "Vikram Singh",
    text: "Mujhe ek natural herbal blend chahiye tha daily wellness ke liye. BioSurge ka texture aur honey based taste kaafi acha laga.",
    image: l1
  },
  {
    id: 3,
    name: "Arjun Mehta",
    text: "Delivery smooth thi aur product quality genuine lagi. Regular routine me use karna convenient hai aur overall achha experience raha.",
    image: l1
  }
];;

const Testimonials = () => {
  return (
    <section className="tm-section">
      <div className="tm-container">
        <div className="tm-header">
          <h2 className="tm-title">What Our <span className="text-green">Family</span> Says</h2>
        </div>

        <div className="tm-slider-wrapper">
          <motion.div 
            className="tm-slider-track"
            drag="x"
            dragConstraints={{ right: 0, left: -600 }} // Adjust based on card count
          >
            {reviews.map((review) => (
              <div className="tm-slide-card" key={review.id}>
                <div className="card-top">
                    <FaQuoteLeft className="quote-icon-small" />
                    <div className="tm-img-border">
                        <img src={review.image} alt={review.name} className="tm-user-img" />
                    </div>
                    <FaQuoteRight className="quote-icon-small" />
                </div>
                
                <div className="tm-content">
                  <h4 className="tm-name">{review.name} <FaCheckCircle className="verified-icon" /></h4>
                  <p className="tm-text">{review.text}</p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
        <p className="tm-header">
  *These are individual customer experiences. Results may vary from person to person.
</p>
        <p className="swipe-hint">← Swipe to read more →</p>
      </div>
    </section>
  );
};

export default Testimonials;